import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useEventListener } from "../../../hooks";

/**
 * HOC has one tiny purpose - it disables click event that happens after ScrollContainer has been dragged
 * Reason: raw event listeners are required to stop nativeEvent propagation
 */
export default function withScrollClickSuppression(WrappedScrollContainer) {
  function ScrollClickSuppressor(props) {
    var domNodeRef = props.domNodeRef;
    var isScroll = false;
    var handleClick = function handleClick(event) {
      if (isScroll) {
        event.stopPropagation();
        event.preventDefault();
      }
    };
    var handleScrollEnd = function handleScrollEnd() {
      setTimeout(function () {
        isScroll = false;
      });
      if (props.UNSAFE_onScrollEnd) props.UNSAFE_onScrollEnd.apply(props, arguments);
    };
    var handleScroll = function handleScroll(opts) {
      var movement = opts.movement;
      if (Math.abs(movement[0]) > 2 || Math.abs(movement[1] > 2)) isScroll = true;
      if (props.UNSAFE_onScroll) props.UNSAFE_onScroll(opts);
    };
    useEventListener('click', handleClick, domNodeRef);
    return /*#__PURE__*/React.createElement(WrappedScrollContainer, _extends({}, props, {
      UNSAFE_onScroll: handleScroll,
      UNSAFE_onScrollEnd: handleScrollEnd,
      "data-t-id": "ScrollContainerV2-enhancers"
    }));
  }
  ScrollClickSuppressor.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, WrappedScrollContainer.propTypes) : {};
  if (process.env.NODE_ENV !== 'production') {
    ScrollClickSuppressor.displayName = 'ScrollClickSuppressor';
  }
  return ScrollClickSuppressor;
}